import React from "react";
import {useSelector} from "react-redux";
import {IntlProvider} from "react-intl";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/dist/locale-data/en";
import "@formatjs/intl-relativetimeformat/dist/locale-data/de";
import "@formatjs/intl-relativetimeformat/dist/locale-data/es";
import "@formatjs/intl-relativetimeformat/dist/locale-data/it";
import "@formatjs/intl-relativetimeformat/dist/locale-data/nl";

import deMessages from "./messages/de";
import enMessages from "./messages/en";
import esMessages from "./messages/es";
import itMessages from "./messages/it";
import nlMessages from "./messages/nl";

const allMessages = {
    de: deMessages,
    en: enMessages,
    es: esMessages,
    it: itMessages,
    nl: nlMessages,
};

const locales = {
    1: 'en',
    2: 'nl',
    3: 'de',
    4: 'it',
    5: 'es',
}

const getLocaleFromLanguageId = (languageId) => {
    return locales[languageId] || 'en';
}

export default function I18nProvider({children}) {
    const locale = useSelector(({i18n}) => i18n.lang);
    const messages = allMessages[locale];

    return (
        <IntlProvider locale={locale} messages={messages}>
            {children}
        </IntlProvider>
    );
}

export {getLocaleFromLanguageId}
